import React from 'react'
import { Card, CardBody, CardHeader,Container } from 'reactstrap'
import styles from './cashaward.css'

import ECA10Eggdesktop from '../../../assets/cashaward/anthe/class_x_engg.png'
import ECA10Eggmobile768 from '../../../assets/cashaward/anthe/class_x_engg_tab.png'
import ECA10Eggmobil386 from '../../../assets/cashaward/anthe/class_x_engg_m.png'

import ECA10Medicaldesktop from '../../../assets/cashaward/anthe/class_x_medical.png'
import ECA10Medicalmobile768 from '../../../assets/cashaward/anthe/class_x_medical_tab.png'
import ECA10Medicalmobil386 from '../../../assets/cashaward/anthe/class_x_medical_m.png'

import ECA1112EnggDesktop from '../../../assets/cashaward/anthe/class_xi_xii_engg.png'
import ECA1112Enggmobile786 from '../../../assets/cashaward/anthe/class_xi_xii_engg_tab.png'
import ECA1112Enggmobil386 from '../../../assets/cashaward/anthe/class_xi_xii_engg_m.png'

import ECA1112MedicalDesktop from '../../../assets/cashaward/anthe/class_xi_xii_medical.png'
import ECA1112Medicalmobile786 from '../../../assets/cashaward/anthe/class_xi_xii_medical_tab.png'
import ECA1112Medcialmobil386 from '../../../assets/cashaward/anthe/class_xi_xii_medical_m.png'

import ECAViiiDesktop from '../../../assets/cashaward/anthe/class_vii_viii_ix.png'
import ECAViiimobile768 from '../../../assets/cashaward/anthe/class_vii_viii_ix_tab.png'
import ECAViiimobil386 from '../../../assets/cashaward/anthe/class_vii_viii_ix_m.png'

import desktop_5_6 from '../../../assets/cashaward/anthe/class_v_vi.png'
import desktop_7_9 from '../../../assets/cashaward/desktop/class_vii_viii_ix.png'
import desktop_10 from '../../../assets/cashaward/desktop/class_x.png'
import desktop_11_12 from '../../../assets/cashaward/desktop/class_xi_xii.png'

import mobile_5_6 from '../../../assets/cashaward/anthe/class_v_vi_m.png'
import mobile_7_9 from '../../../assets/cashaward/mobile/class_vii_viii_ix.png'
import mobile_10 from '../../../assets/cashaward/mobile/class_x.png'
import mobile_11_12 from '../../../assets/cashaward/mobile/class_xi_xii.png'

import tablet_5_6 from '../../../assets/cashaward/anthe/class_v_vi_tab.png'
import tablet_7_9 from '../../../assets/cashaward/tablet/class_vii_viii_ix.png'
import tablet_10 from '../../../assets/cashaward/tablet/class_x.png'
import tablet_11_12 from '../../../assets/cashaward/tablet/class_xi_xii.png'

import AktheCA10 from '../../../assets/cashaward/Akthe/akthe_CA_10.png'
import AKTHECA1112 from '../../../assets/cashaward/Akthe/akthe_CA_1112.png'
import AKthe789 from '../../../assets/cashaward/Akthe/akthe_CA_789.png'

import AktheMobile_10 from '../../../assets/cashaward/Akthe/Akthe_m_10.png'
import AktheMobile_1112 from '../../../assets/cashaward/Akthe/Akthe_m_1112.png'
import AktheMobile_789 from '../../../assets/cashaward/Akthe/Akthe_m_789.png'
import { connect } from 'react-redux'

const mapStateToProps = (state) => ({
  profileInfo: state?.profileData
})

const CashAwards = (props) => {
  return (
    <div>
      <Container className="px-lg-0 px-xl-0 px-3 pb-lg-0 pb-xl-3 mh-100 maxw-11">
        {/* For Class V & VI Studying Students */}
        {props.profileInfo.exam_type === "ANTHE" && (
        (props?.class_studying == 'V' || props?.class_studying == 'VI') && (
          <div className='mt-3 mt-lg-2'>
            <img src={desktop_5_6} alt="cash awards" className='desktopview img-fluid' />
            <img src={tablet_5_6} alt="cash awards" className='mobileview img-fluid' />
            <img src={mobile_5_6} alt="cash awards" className='mobileview368 img-fluid' />
          </div>
        )
      )}

        {/* ANTHE For Class VII, VIII & IX Studying Students */}
        {props.profileInfo.exam_type === "ANTHE" && (
        (props?.class_studying == 'VII' || props?.class_studying == 'VIII' || props?.class_studying == 'IX') && (
          <div className='mt-3 mt-lg-2'>
            {props?.profileInfo?.anthetwo ?
              <>
                <img src={desktop_7_9} alt="cash awards" className='desktopview img-fluid' />
                <img src={tablet_7_9} alt="cash awards" className='mobileview img-fluid' />
                <img src={mobile_7_9} alt="cash awards" className='mobileview368 img-fluid' />
              </> :
              <>
                <img src={ECAViiiDesktop} alt="cash awards" className='desktopview img-fluid' />
                <img src={ECAViiimobile768} alt="cash awards" className='mobileview img-fluid' />
                <img src={ECAViiimobil386} alt="cash awards" className='mobileview368 img-fluid' />
              </>
            }
          </div>
        )
      )}

       {/* AKTHE For Class VII, VIII & IX Studying Students */}
        {props.profileInfo.exam_type === "AKTHE" && (
        (props?.class_studying == 'VII' || props?.class_studying == 'VIII' || props?.class_studying == 'IX') && (
          <div className='mt-3 mt-lg-2'>
                <img src={AKthe789} alt="cash awards" className='desktopview img-fluid' />
                <img src={AktheMobile_789} alt="cash awards" className='mobileview img-fluid' />
                <img src={AktheMobile_789} alt="cash awards" className='mobileview368 img-fluid' />
          </div>
        )
      )}

        {/* ANTHE Class X Studying Students (Medical & Engineering Aspirants) */}
        {props.profileInfo.exam_type === "ANTHE" && (
        props?.class_studying == 'X' && (
          <div className='mt-3 mt-lg-2'>
            {props?.profileInfo?.anthetwo ? (
              <>
                <img src={desktop_10} alt="cash awards" className='desktopview img-fluid' />
                <img src={tablet_10} alt="cash awards" className='mobileview img-fluid' />
                <img src={mobile_10} alt="cash awards" className='mobileview368 img-fluid' />
              </> 

            ) : props.profileInfo.stream === "SOE" ? (
              <>
                <img src={ECA10Eggdesktop} alt="cash awards" className="desktopview img-fluid" />
                <img src={ECA10Eggmobile768} alt="cash awards" className="mobileview img-fluid" />
                <img src={ECA10Eggmobil386} alt="cash awards" className="mobileview368 img-fluid" />
              </>
            ) : (
              <>
                <img src={ECA10Medicaldesktop} alt="cash awards" className="desktopview img-fluid" />
                <img src={ECA10Medicalmobile768} alt="cash awards" className="mobileview img-fluid" />
                <img src={ECA10Medicalmobil386} alt="cash awards" className="mobileview368 img-fluid" />
              </>
            )}            
          </div>
        )
        )}

        {/*Akthe Class X Studying Students (Medical & Engineering Aspirants) */}
        {props.profileInfo.exam_type === "AKTHE" && (
        props?.class_studying == 'X' && (
          <div className='mt-3 mt-lg-2'>
                <img src={AktheCA10} alt="cash awards" className='desktopview img-fluid' />
                <img src={AktheMobile_10} alt="cash awards" className='mobileview img-fluid' />
                <img src={AktheMobile_10} alt="cash awards" className='mobileview368 img-fluid' />
          </div>
        )
        )}
        
        {/* ANTHE For Class XI & XII Studying & XII Passed Students (Medical & Engineering Aspirants) */}
        {props.profileInfo.exam_type === "ANTHE" && (
        (props?.class_studying == "XI" || props?.class_studying == 'XII' || props?.class_studying == 'XII Passed') && (
          <div className='mt-3 mt-lg-2'>
            {props?.profileInfo?.anthetwo ?(
              <>
                <img src={desktop_11_12} alt="cash awards" className='desktopview img-fluid' />
                <img src={tablet_11_12} alt="cash awards" className='mobileview img-fluid' />
                <img src={mobile_11_12} alt="cash awards" className='mobileview368 img-fluid' />
              </> 
              ) : props.profileInfo.stream === "SOE" ? (
              <>
                <img src={ECA1112EnggDesktop} alt="cash awards" className='desktopview img-fluid' />
                <img src={ECA1112Enggmobile786} alt="cash awards" className='mobileview img-fluid' />
                <img src={ECA1112Enggmobil386} alt="cash awards" className='mobileview368 img-fluid' />
              </>
                ) : (
                  <>
                <img src={ECA1112MedicalDesktop} alt="cash awards" className='desktopview img-fluid' />
                <img src={ECA1112Medicalmobile786} alt="cash awards" className='mobileview img-fluid' />
                <img src={ECA1112Medcialmobil386} alt="cash awards" className='mobileview368 img-fluid' />
              </>
            )}  
          </div>
        )
      )}

        {/* AKTHE For Class XI & XII Studying & XII Passed Students (Medical & Engineering Aspirants) */}
        {props.profileInfo.exam_type === "AKTHE" && (
        (props?.class_studying == "XI" || props?.class_studying == 'XII' || props?.class_studying == 'XII Passed') && (
          <div className='mt-3 mt-lg-2'>
                <img src={AKTHECA1112} alt="cash awards" className='desktopview img-fluid' />
                <img src={AktheMobile_1112} alt="cash awards" className='mobileview img-fluid' />
                <img src={AktheMobile_1112} alt="cash awards" className='mobileview368 img-fluid' />
          </div>
        )
        )}

         {/* <Card className='mt-3 mt-lg-2 border-0'>
                <CardHeader className="bg-soft-red rounded-top border-0 py-2 px-5 text-white font-size-md m-0 fw-700 text-center">
                ELIGIBLE CASH AWARDS
                </CardHeader>
                <CardBody className="cash-awards">
                    <div className='d-flex justify-content-between align-items-center pb-2 pt-1  border-dotted-bottom'> 
                      <div>
                       <h6 className='text-black fw-lighter mb-0 font-size-sm font-size-lg-md font-size-sm'> Classroom / ALC Courses (Type A)</h6>
                      
                       </div>
                       <div className='d-flex justify-content-between'>
                        <p className='text-grey fw-lighter mb-0 font-size-sm font-size-lg-md' style={{display:"block ruby"}}><span className='text-black'>₹ 100000/-</span></p>
                       </div>
                    </div>
                    <div className='d-flex justify-content-between align-items-center pb-2 border-dotted-bottom pt-2'> 
                      <div>
                       <h6 className='text-black fw-lighter mb-0 font-size-sm font-size-lg-md'> Long-Term Digital Course (Type B)</h6>
                      
                       </div>
                       <div className='d-flex justify-content-between'>
                        <p className='text-black fw-lighter mb-0 font-size-sm font-size-lg-md' style={{display:"block ruby"}}><span className='text-black'>₹ 50000/-</span></p>
                       </div>
                    </div>
                    <div className='d-flex justify-content-between align-items-center pb-2  border-dotted-bottom pt-2 '> 
                      <div>
                       <h6 className='text-black fw-lighter mb-0  font-size-sm font-size-lg-md'> DLP Course (Type C)</h6>
                      
                       </div>
                       <div className='d-flex justify-content-between'>
                        <p className='text-grey fw-lighter mb-0 font-size-sm font-size-lg-md' style={{display:"block ruby"}}><span className='text-black'>₹ 50000/-</span></p>
                       </div>
                    </div>
                    <div className='pt-3 d-flex justify-content-between'>
                      <p className='font-size-xs text-black fw-400 mb-0'>*To be eligible for Cash Award, it is mandatory to join our Classroom Course, ALC Course, Long Term Digital Course or DLP as applicable before <strong>1st March 2025</strong></p>
                    </div>
                </CardBody>
            </Card> */}
            <Card className='mt-4 border-0 d-sm-block d-none'>
                <CardHeader className="bg-dark-green rounded border-0 py-3 px-5 text-white m-0 fw-lighter text-center fs-li">
                Limited Seats. Admission is on a First Come, First Serve Basis. Valid until <span className='text-yellow'>{props?.profileInfo?.anthetwo ? "31st March 2025": "31st December 2025"}</span>
                </CardHeader>
          </Card>
          </Container>
          <Card className='mt-4 border-0 d-block d-sm-none'>
                <CardHeader className="bg-dark-green rounded-0 border-0 py-2 px-2 text-white m-0 fw-lighter text-center fs-li">
                Limited Seats. Admission is on a First Come, First Serve Basis. Valid until <span className='text-yellow'>{props?.profileInfo?.anthetwo ? "31st March 2025": "31st December 2025"}</span>
                </CardHeader>
          </Card>
    </div>
  )
}

export default connect(mapStateToProps)(CashAwards)